import React from 'react';
import { createGlobalStyle } from 'styled-components';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Builders from './components/Builders/Builders';
import About from './components/About/About';
import USP from './components/USP/USP';
import Amenities from './components/Amenities/Amenities';
import Location from './components/Location/Location';
import Media from './components/Media/Media';
import AboutCompany from './components/About/AboutCompany';
import ContactForm from './components/Contact/ContactForm';
import Footer from './components/Footer/Footer';
import { colors } from './styles/colors';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${colors.darkGrey};
    background: ${colors.white};
  }

  html {
    scroll-behavior: smooth;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <Header />
      <main>
        <Hero />
        <Builders />
        <About />
        <USP />
        <Amenities />
        <Location />
        <Media />
        <ContactForm />
        <AboutCompany />
      </main>
      <Footer />
    </>
  );
}

export default App;
